/**
 * PAWD Performance — Lighthouse optimization helpers
 * - Delays non-critical third-party scripts injected via {{ content_for_header }}
 * - Patches bfcache-breaking patterns
 * - Batches DOM reads to prevent forced reflow
 */
(function () {
  'use strict';

  // 1. Delay third-party script execution
  //    Intercepts dynamically-created script tags from app embeds
  //    and delays non-essential ones until after page load + 3s idle
  var _origCreateElement = document.createElement.bind(document);
  var _delayPatterns = /rebuyengine|juniphq|junip-store|rebuy/i;
  var _delayed = [];
  var _loaded = false;

  function flushDelayed() {
    if (_loaded) return;
    _loaded = true;
    _delayed.forEach(function (attrs) {
      var s = _origCreateElement('script');
      if (attrs.src) s.src = attrs.src;
      if (attrs.id) s.id = attrs.id;
      if (attrs.type) s.type = attrs.type;
      s.defer = true;
      if (attrs.dataset) {
        Object.keys(attrs.dataset).forEach(function (k) {
          s.dataset[k] = attrs.dataset[k];
        });
      }
      document.body.appendChild(s);
    });
    _delayed = [];
  }

  // Flush after load + 3 seconds idle
  if (document.readyState === 'complete') {
    setTimeout(flushDelayed, 3000);
  } else {
    window.addEventListener('load', function () {
      setTimeout(flushDelayed, 3000);
    });
  }

  // 2. Ensure bfcache compatibility
  //    Replace any 'unload' listeners with 'pagehide'
  var _origAddEventListener = window.addEventListener.bind(window);
  window.addEventListener = function (type, listener, options) {
    if (type === 'unload') {
      type = 'pagehide';
    }
    return _origAddEventListener(type, listener, options);
  };
})();
